/**
 * بخش مسیر عمومی دوره برای لینک و ناوبری: ترجیح با اسلاگ (از عنوان)، در غیر این صورت id.
 */
export function getCoursePathSegment(course: { slug?: string | null; id: string }): string {
  const s = (course.slug != null && String(course.slug).trim()) ? String(course.slug).trim() : course.id;
  return s;
}
